(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme14plus-store-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('theme14plus-store-stock')) {
    customElements.define(
      'theme14plus-store-stock',
      class Theme14PlusStoreStock extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.theme14plus-store-stock__trigger');
          this.triggerLabel = this.querySelector('[data-store-stock-trigger-label]');
          this.stockData = this.parseStockData();
          this.productForm = document.getElementById(this.dataset.productFormId);
          this.variantInput = document
            .getElementById(this.dataset.productFormId)
            ?.querySelector('input[name="id"]');
          this.submitButton = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
          this.submitButtonLabel = this.submitButton?.querySelector('span');

          this.onTriggerClick = this.handleTriggerClick.bind(this);
          this.onVariantChange = this.handleVariantChange.bind(this);
          this.onSubmitButtonMutation = this.syncEmphasisState.bind(this);

          this.trigger?.addEventListener('click', this.onTriggerClick);
          this.variantInput?.addEventListener('change', this.onVariantChange);
          this.initializeSubmitButtonObserver();

          this.update(this.variantInput?.value || '');
        }

        disconnectedCallback() {
          this.trigger?.removeEventListener('click', this.onTriggerClick);
          this.variantInput?.removeEventListener('change', this.onVariantChange);
          this.submitButtonObserver?.disconnect();

          if (this.modal?.parentNode === document.body) {
            this.modal.remove();
          }
        }

        parseStockData() {
          const node = this.querySelector('[data-store-stock-json]');
          if (!node) return null;

          try {
            return JSON.parse(node.textContent);
          } catch (error) {
            console.error(error);
            return null;
          }
        }

        handleTriggerClick(event) {
          if (this.trigger.disabled) {
            event.preventDefault();
            return;
          }

          this.resolveModalParts();
          this.modal?.show(this.trigger);
        }

        handleVariantChange(event) {
          this.update(event.target.value || '');
        }

        initializeSubmitButtonObserver() {
          if (!this.submitButton) return;

          this.submitButtonObserver = new MutationObserver(this.onSubmitButtonMutation);
          this.submitButtonObserver.observe(this.submitButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
          });

          if (this.submitButtonLabel) {
            this.submitButtonObserver.observe(this.submitButtonLabel, {
              childList: true,
              characterData: true,
              subtree: true,
            });
          }
        }

        getVariantData(variantId) {
          if (!this.stockData || !variantId) return null;

          const variantGid = 'gid://shopify/ProductVariant/' + variantId;
          return this.stockData.variants?.[variantGid] || null;
        }

        getStoreDetails(storeId) {
          const rawStore = this.stockData?.stores?.[storeId];

          if (typeof rawStore === 'string') {
            return {
              storeId,
              storeCode: '',
              storeName: rawStore,
              address: '',
            };
          }

          if (rawStore && typeof rawStore === 'object') {
            return {
              storeId,
              storeCode: String(rawStore.storeCode || ''),
              storeName: rawStore.storeName || rawStore.name || storeId,
              address: rawStore.address || '',
            };
          }

          return {
            storeId,
            storeCode: '',
            storeName: storeId,
            address: '',
          };
        }

        getAvailableStores(variantId) {
          const variantData = this.getVariantData(variantId);
          if (!variantData || !variantData.stocks) return [];

          return Object.entries(variantData.stocks)
            .filter(([, quantity]) => Number(quantity) > 0)
            .map(([storeId]) => this.getStoreDetails(storeId))
            .sort((leftStore, rightStore) => {
              if (leftStore.storeCode && rightStore.storeCode) {
                return leftStore.storeCode.localeCompare(rightStore.storeCode, 'ja', { numeric: true });
              }

              if (leftStore.storeCode) return -1;
              if (rightStore.storeCode) return 1;

              return leftStore.storeName.localeCompare(rightStore.storeName, 'ja', { numeric: true });
            });
        }

        buildMapsUrl(storeName) {
          const prefixedStoreName = `イチヨンプラス ${storeName}`;
          return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(prefixedStoreName)}`;
        }

        groupStoresByAddress(stores) {
          const hasAddressGroups = stores.some((store) => store.address);
          if (!hasAddressGroups) {
            return [
              {
                address: '',
                stores,
              },
            ];
          }

          const groups = [];
          const groupMap = new Map();

          stores.forEach((store) => {
            const groupKey = store.address || '';

            if (!groupMap.has(groupKey)) {
              const group = {
                address: groupKey,
                stores: [],
              };

              groupMap.set(groupKey, group);
              groups.push(group);
            }

            groupMap.get(groupKey).stores.push(store);
          });

          return groups;
        }

        renderStoreGroups(stores) {
          const groups = this.groupStoresByAddress(stores);
          const hasVisibleHeadings = groups.some((group) => group.address);

          groups.forEach((group) => {
            const groupElement = document.createElement('section');
            groupElement.className = 'theme14plus-store-stock-modal__group';

            if (hasVisibleHeadings && group.address) {
              const title = document.createElement('h3');
              title.className = 'theme14plus-store-stock-modal__group-title';
              title.textContent = group.address;
              groupElement.appendChild(title);
            }

            const groupList = document.createElement('ul');
            groupList.className = 'theme14plus-store-stock-modal__group-list';

            group.stores.forEach((store) => {
              const item = document.createElement('li');
              item.className = 'theme14plus-store-stock-modal__list-item';

              const link = document.createElement('a');
              link.className = 'theme14plus-store-stock-modal__link';
              link.href = this.buildMapsUrl(store.storeName);
              link.rel = 'noopener noreferrer';
              link.target = '_blank';
              link.textContent = store.storeName;

              item.appendChild(link);
              groupList.appendChild(item);
            });

            groupElement.appendChild(groupList);
            this.list.appendChild(groupElement);
          });
        }

        syncEmphasisState() {
          if (!this.trigger) return;

          const submitLabel = this.submitButtonLabel?.textContent?.trim() || '';
          const buttonDisabled =
            this.submitButton?.hasAttribute('disabled') ||
            this.submitButton?.getAttribute('aria-disabled') === 'true';
          const shouldEmphasize =
            this.hasStoreStock &&
            buttonDisabled &&
            [this.dataset.ecSoldOutLabel, this.dataset.ecUnavailableLabel].includes(submitLabel);

          this.classList.toggle('theme14plus-store-stock--emphasized', shouldEmphasize);
          this.trigger.classList.toggle('is-emphasized', shouldEmphasize);
        }

        update(variantId) {
          this.resolveModalParts();

          const stores = this.getAvailableStores(variantId);
          const hasStoreStock = stores.length > 0;
          this.hasStoreStock = hasStoreStock;

          this.trigger.disabled = !hasStoreStock;
          this.trigger.setAttribute('aria-disabled', String(!hasStoreStock));
          this.triggerLabel.textContent = hasStoreStock
            ? this.dataset.availableLabel
            : this.dataset.unavailableLabel;
          this.syncEmphasisState();

          if (!this.list || !this.empty) {
            return;
          }

          this.list.innerHTML = '';

          if (hasStoreStock) {
            this.renderStoreGroups(stores);
          }

          this.list.hidden = !hasStoreStock;
          this.empty.hidden = hasStoreStock;
          this.empty.textContent = this.dataset.emptyLabel;

          if (!hasStoreStock && this.modal?.hasAttribute('open')) {
            this.modal.hide();
          }
        }

        resolveModalParts() {
          if (!this.modal) {
            this.modal = document.getElementById(this.dataset.modalId) || this.querySelector('modal-dialog');
          }

          if (this.modal && !this.list) {
            this.list = this.modal.querySelector('[data-store-stock-list]');
          }

          if (this.modal && !this.empty) {
            this.empty = this.modal.querySelector('[data-store-stock-empty]');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
